module.exports = __webpack_public_path__ + "img/img 2@2x.e46cc3be.png";